/* eslint-disable @angular-eslint/component-max-inline-declarations -- legacy inline template, see rule FE-005 */
import { Component } from '@angular/core'

// Language activation and preloading happen in the appConfig app initializer (see app.config.ts).
// This component is only the content-projection wrapper for the app shell.
@Component({
  selector: 'app-transloco-root',
  template: '<ng-content></ng-content>',
  standalone: true,
  imports: [],
})
export class TranslocoRootComponent {}
